import io from 'socket.io-client';
import { isArtistDemoActive } from '../utils/artistDemoRuntime';

const API_URL = process.env.REACT_APP_API_URL;

let socketInstance = null;
const demoSocket = {
  connected: false,
  connect() { return this; },
  disconnect() { return this; },
  on() { return this; },
  off() { return this; },
  emit() { return this; },
  removeAllListeners() { return this; },
};

function getNativeSocketAuth() {
  if (typeof window === 'undefined') return null;
  const bridge = window.__CASTICART_NATIVE_SOCKET_AUTH__ || window.__CASTICART_NATIVE_AUTH__;
  if (!bridge || typeof bridge !== 'object') return null;
  const authorization = String(
    bridge.authorizationHeader || bridge.authorization || bridge.Authorization || ''
  ).trim();
  const token = String(
    bridge.token || bridge.accessToken || authorization.replace(/^Bearer\s+/i, '')
  ).trim();
  if (!token) return null;
  return {
    token,
    accessToken: token,
    authorizationHeader: authorization || `Bearer ${token}`,
    client: String(bridge.client || 'native').trim(),
    app: String(bridge.app || 'casticart_mac').trim(),
    platform: String(bridge.platform || 'macos').trim(),
    deviceId: String(bridge.deviceId || bridge.deviceID || '').trim(),
  };
}

export function getSocket() {
  if (isArtistDemoActive()) return demoSocket;
  if (!socketInstance) {
    const nativeAuth = getNativeSocketAuth();
    socketInstance = io(API_URL, {
      withCredentials: true,
      autoConnect: false,
      transports: ['websocket'],
      reconnectionDelay: 5000,
      reconnectionDelayMax: 60000,
      randomizationFactor: 0.5,
      timeout: 10000,
      ...(nativeAuth ? { auth: nativeAuth } : {}),
    });
  }
  return socketInstance;
}

export function resetSocket() {
  if (socketInstance) {
    try {
      socketInstance.removeAllListeners();
      socketInstance.disconnect();
    } catch (_) {}
  }
  socketInstance = null;
}
